module.exports = {"id":"206436","name":"Yassine Benzia","rating":"76","photo":"./data/images/photos/3/206436.png","club":{"name":"LOSC","logo":"./data/images/clubs/LOSC.png"},"positions":["MOC","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YassineBenzia0.json
// module id = 4395
// module chunks = 0